// src/components/client-portal/SoloScreen.jsx
// The navy frame the loading, sign-in, expired and error screens share (spec 4.1 to 4.4). Henry's office
// photo sits behind it as a real <picture> with a navy overlay (spec 2.9 and 8.2); with no photo file the
// mockup's radial gradient is the background and the "has-photo" class is left off.
// The foot line renders outside .solo-in, matching the mockup, so the overlay never sits on top of it.
import PortalRoot from "./PortalRoot";
import { officePhoto } from "./portalAssets";

export default function SoloScreen({ screen, children, foot = null }) {
  return (
    <PortalRoot mode="solo">
      <div className={officePhoto ? "solo has-photo" : "solo"} data-screen={screen}>
        {officePhoto ? (
          // The approved mockup (spec 2.9) hides the decorative photo on the <picture> itself; jsx-a11y's
          // element table predates <picture> accepting aria-hidden, so its warning is silenced here.
          // eslint-disable-next-line jsx-a11y/aria-unsupported-elements
          <picture className="solo-photo" aria-hidden="true">
            <source media="(min-width:900px)" srcSet={officePhoto.wide} />
            <img
              src={officePhoto.tall}
              alt=""
              width="1080"
              height="1920"
              decoding="async"
            />
          </picture>
        ) : null}
        <div className="solo-in screen">{children}</div>
        {foot}
      </div>
    </PortalRoot>
  );
}
